export default __webpack_public_path__ + "static/media/M.a6b652ce.png";